import React from 'react';
import useAccessibleClick from '../../../../common/hooks/useAccessibleClick';

const Tab = ({ children, onClick, className }) => {
  const ref = useAccessibleClick(onClick);
  return (
    <div ref={ref} tabIndex={0} onClick={onClick} className={className}>
      {children}
    </div>
  );
};

export default Tab;
